import { useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styled from "styled-components";
import theme from "../../styles/theme";
import { useScreenClass } from "react-grid-system";
import axios from "axios";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Icon, { ClickableIcon } from "../../components/Icon";
import Modal from "../../components/Modal";
import Input, { InputTextArea } from "../../components/Input";
import { StyledText } from "../../components/Text";
import { SaveButton } from "../../components/PillarOverviewModify";
type PillarSubdomainCreateType = {
  isOpen?: boolean;
  currentId?: any;
  header: string;
  mode: "modify" | "create";
  isSnackbarOpen: boolean;
  setIsSnackbarOpen: (x: boolean) => void;
  setMessage: (x: string) => void;
  isErrorOpen: boolean;
  setIsErrorOpen: (x: boolean) => void;
  setOpen: (x: boolean) => void;
  knowledge_topics?: {
    id: string;
    description: string;
    title: string;
  };
  onSaveComplete: () => void;
};

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 20px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
interface SkillwInputs {
  title: string;
  description: string;
}

const KnowledgeTopicCreate = ({
  isOpen,
  setOpen,
  header,
  mode,
  knowledge_topics,
  currentId,
  onSaveComplete,
  isSnackbarOpen,
  setIsSnackbarOpen,
  setMessage,
  isErrorOpen,
  setIsErrorOpen
}: PillarSubdomainCreateType): JSX.Element => {
  const screenClass = useScreenClass();
  const [openTopic, setOpenTopic] = useState<boolean>(false);
  const [count, setCount] = useState({ name: 0, description: 0 });

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<SkillwInputs>({
    mode: "onBlur",
    defaultValues: {
      title: knowledge_topics ? knowledge_topics.title : "",
      description: knowledge_topics ? knowledge_topics.description : "",
    },
  });
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const createKnowledgeTopic = (data: any) => {
    axios
      .post("/knowledgetopic/new", { ...data, area_id: currentId.area_id })
      .then((res: any) => {
        setIsSnackbarOpen(true);
        setMessage("Created knowledge topic Successfully!");
        onSaveComplete();
      })
      .catch((error:any) => {
        setIsErrorOpen(true);
        setMessage(
          error?.response?.data?.error || "Failed to create knowledge topic!"
        );
      });
  };
  return (
    <>
      <form onSubmit={handleSubmit(createKnowledgeTopic)}>
       
        <CustomFlex
          style={{
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 15,
          }}
        >
          <FlexGrow>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Title <span style={{ color: "red" }}> *</span></Label>
              </CustomGrowPlain>
              <FlexGrow>
                <Input
                  maxLength={64}
                  style={{ width: "100%" }}
                  isFullWidth
                  {...register("title", { required: true })}
                />
                {errors.title && (
                  <p
                    style={{
                      marginTop: 0,
                      color: theme.color.red800,
                    }}
                  >
                    This field is required
                  </p>
                )}
              </FlexGrow>
            </CustomFlexPlain>
            <CustomFlexPlain>
              <CustomGrowPlain>
                <Label>Description</Label>
              </CustomGrowPlain>
              <FlexGrow>
                <FlexBox
                  space={0}
                  alignItems="start"
                  style={{ width: "100%" }}
                  direction="column"
                >
                  <FlexGrow style={{ width: "100%" }}>
                    {/* <InputTextArea
                        isFullWidth
                        style={{ minHeight: "100px", width: "100%" }}
                        // onChange={e => setCount(e.target.value.length)}
                        {...register("description")}
                      /> */}
                    <Controller
                      name="description"
                      control={control}
                      render={({ field }) => (
                        <InputTextArea
                          isFullWidth
                          style={{ minHeight: "100px", width: "100%" }}
                          // value={field.value}
                          maxLength={2048}
                          onChange={(e: any) => {
                            field.onChange(e);
                            setCount({
                              ...count,
                              description: e.target.value.length,
                            });
                          }}
                        />
                      )}
                    />
                  </FlexGrow>
                  <FlexGrow style={{ textAlign: "end" }}>
                    <StyledText
                      style={{ fontSize: "14px" }}
                      color={theme.color.lightBlueGray500}
                    >
                      {count.description}/2048
                    </StyledText>
                  </FlexGrow>
                </FlexBox>
              </FlexGrow>
            </CustomFlexPlain>
            <FlexBox>
              <FlexGrow></FlexGrow>
              <Button
                className="reduce_opct_onhover"
                type="button"
                onClick={() => setOpen(false)}
                style={{
                  border: "2px solid #64748B",
                  padding: "8px 40px",
                  fontSize: "14px",
                }}
              >
                Cancel
              </Button>
              <SaveButton
                className="reduce_opct_onhover"
                style={{
                  padding: "8px 40px",
                  color: "white",
                }}
              >
                <Icon style={{ paddingRight: "8px" }} name={"save"} />Save
              </SaveButton>
            </FlexBox>
          </FlexGrow>
        </CustomFlex>
      </form>
    </>
  );
};
export default KnowledgeTopicCreate;
